module.exports = __webpack_public_path__ + "img/shouye.c06ad27f.png";